// TODO: this file has two anys. We tried to get rid of them, but sadly we
// couldn't find a way to do so. Will need to clean this up in the future.
import { LogLevel, getLogger } from '@foundation-player/logger';
import { mergeEvent } from './merge-event';
import { FoundationEvent, FoundationEventBase } from './unfiltered';

type Mapping<SourceEvent, EventSource> = (
  event: SourceEvent,
  eventSource: EventSource,
) => FoundationEventBase<SourceEvent> | undefined;
export type PayloadMapping<SourceType extends string, EventSource> = Partial<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Record<SourceType, FoundationEvent | Mapping<any, EventSource>>
>;

/**
 * @param eventSource Object containing the playable element that triggers the event.
 * @param eventMapping Object that contains key-value mappings from the original event type to a foundation event.
 * @param event The original event. Should not but may be undefined when receiving events from smartclip.
 * @param wrapOriginalEvent If true, the passed `event` will be wrapped into a seperate property called `originalEvent`.
 * @returns The mapped event or `void` if the event can not be mapped.
 */
export function eventMapper<SourceType extends string, EventSource>(
  eventSource: EventSource,
  eventMapping: PayloadMapping<SourceType, EventSource>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event?: any,
  wrapOriginalEvent = true,
): FoundationEventBase | undefined {
  const logger = getLogger('player.core.eventMapper');

  if (!event?.type) {
    // Additional check prevents performance issues by JSON.stringify even if it's not logged
    if (logger.isLoggingActiveForLevel(LogLevel.Trace)) {
      logger.trace(`Unknown event can not be mapped: ${JSON.stringify(event, null, 2)}`);
    }
    return;
  }

  const mapping = eventMapping[event.type as keyof typeof eventMapping];

  if (!mapping) {
    if (logger.isLoggingActiveForLevel(LogLevel.Trace)) {
      logger.trace(`Mapping does not exist for : ${event.type}`);
    }
    return;
  }

  if (typeof mapping === 'string') {
    if (wrapOriginalEvent) {
      return new FoundationEventBase(mapping as FoundationEvent, { originalEvent: event });
    }

    return mergeEvent(new Event(mapping), event) as FoundationEventBase;
  } else {
    return mapping(event, eventSource);
  }
}
